import { Button } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../../components/inputs/textInput";
import { divideAndDisplay } from "../../../../scripts/functions";

const GoldModal = ({
  data,
  changedData,
  setChangedData,
  setData,
  profit,
  setProfit,
  hojrat,
  setHojrat,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const updateHojrat = (
    amount,
    price,
    hojratValue,
    profitValue,
    name,
    value
  ) => {
    const p1 = Number(amount) * Number(price);
    const p2 = (p1 * hojratValue) / 100;

    const p4 = (p1 * profitValue) / 100;
    if (name) {
      setChangedData({
        ...changedData,
        moConstructionPrice: divideAndDisplay(p2),
        moProfitPrice: divideAndDisplay(p4),
        [name]: value,
      });
    } else {
      setChangedData({
        ...changedData,
        moConstructionPrice: divideAndDisplay(p2),
        moProfitPrice: divideAndDisplay(p4),
      });
    }
  };
  useEffect(() => {
    if (!changedData.moConstructionPrice && !changedData.moProfitPrice) {
      updateHojrat(
        changedData.flAmount,
        changedData.moUnitPrice,
        hojrat,
        profit
      );
    }
  }, []);
  return (
    <div>
      {" "}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { md: "90%", xs: "90%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          pb: { md: 2, xs: 11 },
          borderRadius: 2,
          overflow: "auto",
          maxHeight: "95%",
          maxWidth: "400px",
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="border-b border-solid border-[#bbcfec] pb-4">
            <h2 className="text-sm font-bold">{data?.chTitle}</h2>
          </div>
          <TextInput
            label="عنوان ارسالی"
            onChange={(e) =>
              setChangedData({ ...changedData, chSellerStuffSendName: e })
            }
            value={changedData.chSellerStuffSendName}
          />
          <TextInput
            label=" تعداد/مقدار"
            onChange={(e) => {
              var nm = e.replaceAll(",", "");
              updateHojrat(
                Number(nm),
                changedData.moUnitPrice,
                hojrat,
                profit,
                "flAmount",
                e
              );
            }}
            onBlur={(e) => {
              var nm = e.replaceAll(",", "");
              setChangedData({ ...changedData, flAmount: nm });
            }}
            value={String(changedData.flAmount)}
            number
          />
          <TextInput
            label=" مبلغ واحد"
            onChange={(e) => {
              var nm = e.replaceAll(",", "");
              updateHojrat(
                changedData.flAmount,
                Number(nm),
                hojrat,
                profit,
                "moUnitPrice",
                e
              );
            }}
            value={changedData.moUnitPrice || ""}
            price
            number
          />
          <div className="grid gap-1 grid-cols-3">
            <div className="col-span-1">
              {" "}
              <TextInput
                label=" درصد اجرت"
                onChange={(e) => {
                  localStorage.setItem("hojrat", e);
                  setHojrat(e);
                  const p1 =
                    Number(changedData.flAmount) *
                    (Number(changedData.moUnitPrice) -
                      Number(changedData.moDiscount));
                  const p2 = (p1 * e) / 100;
                  setChangedData({ ...changedData, moConstructionPrice: p2 });
                }}
                value={hojrat}
                number
                allowZero
                price
                priceLabel="%"
              />
            </div>
            <div className="col-span-2">
              {" "}
              <TextInput
                label=" اجرت ساخت"
                onChange={(e) => {
                  const p1 = Number(e) * 100;
                  const p2 =
                    p1 / (changedData.moUnitPrice * changedData.flAmount);

                  localStorage.setItem("hojrat", divideAndDisplay(p2));
                  setHojrat(divideAndDisplay(p2));

                  setChangedData({ ...changedData, moConstructionPrice: e });
                }}
                value={changedData.moConstructionPrice || ""}
                number
                allowZero
                price
              />
            </div>
          </div>{" "}
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-1">
              {" "}
              <TextInput
                label=" درصد سود"
                onChange={(e) => {
                  localStorage.setItem("profit", e);

                  setProfit(e);
                  const p1 =
                    Number(changedData.flAmount) *
                    (Number(changedData.moUnitPrice) -
                      Number(changedData.moDiscount));
                  const p2 = (p1 * e) / 100;
                  setChangedData({ ...changedData, moProfitPrice: p2 });
                }}
                value={profit}
                number
                allowZero
                price
                priceLabel="%"
              />
            </div>
            <div className="col-span-2">
              <TextInput
                label=" سود فروشنده"
                onChange={(e) => {
                  const p1 = Number(e) * 100;

                  const p2 =
                    p1 / (changedData.moUnitPrice * changedData.flAmount);

                  localStorage.setItem("profit", divideAndDisplay(p2));
                  setProfit(divideAndDisplay(p2));

                  setChangedData({ ...changedData, moProfitPrice: e });
                }}
                value={changedData.moProfitPrice || ""}
                number
                allowZero
                price
              />
            </div>
          </div>
          <TextInput
            label=" حق العمل"
            onChange={(e) => setChangedData({ ...changedData, moWorkPrice: e })}
            value={changedData.moWorkPrice || ""}
            number
            allowZero
            price
          />
          <TextInput
            label=" تخفیف"
            onChange={(e) => setChangedData({ ...changedData, moDiscount: e })}
            value={changedData.moDiscount || ""}
            number
            allowZero
            price
          />{" "}
          {/*     <TextInput
            label="  مالیات بر ارزش افزوده "
            onChange={(e) =>
              setChangedData({ ...changedData, flValueAddedPercent: e })
            }
            value={changedData.flValueAddedPercent}
            number
            allowZero
            price
            priceLabel="%"
          /> */}
        </div>
        <div className="flex col-span-2 justify-between items-center mt-5">
          <Button
            disabled={
              changedData?.flAmount === undefined ||
              /*               !changedData?.chSellerStuffSendName ||
               */ !changedData?.moUnitPrice /* ||
              !changedData?.moProfitPrice ||
              !changedData?.moConstructionPrice */
            }
            onClick={() => {
              setData(changedData);
              if (id) {
                navigate(`/sell/invoice/${id}`);
              } else {
                navigate(`/sell/invoice/create`);
              }
            }}
            sx={{ width: "8rem" }}
            variant="contained"
            color="primary"
          >
            <> ویرایش</>
          </Button>{" "}
          <Button
            onClick={() => {
              if (id) {
                navigate(`/sell/invoice/${id}`);
              } else {
                navigate(`/sell/invoice/create`);
              }
              setChangedData(data);
            }}
            sx={{ width: "8rem", background: "#ccc" }}
            variant="contained"
            color="inherit"
          >
            انصرف
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default GoldModal;
